import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPieChart = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.457 18.517A8.5 8.5 0 1 1 11.25 3.532v8.252a.75.75 0 0 0 .21.52zm1.06-1.06L12.75 11.48V3.533a8.5 8.5 0 0 1 5.768 13.923M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPieChart;
